// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rbbz","left":"styles_left__34i03"};